import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import { EmailGroupService } from "../../services";
import { ConfirmDialog, WarnDialog } from '../../components/shared';
import 'date-fns';
import { Box, Button, Backdrop, TextField, Card, CircularProgress, Container, Grid, InputLabel, Chip, IconButton } from '@material-ui/core';
import { Formik, Form, useFormik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { ContentSave, Delete, CogOutline, EmailEditOutline, PlusCircleOutline } from 'mdi-material-ui';
import EditDialog from './EditDialog';
import 'react-medium-image-zoom/dist/styles.css'

const useStyles = makeStyles((theme) => ({
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    formCard: {
        display: 'flex',
        marginTop: 10,
        marginBottom: 10,
        paddingTop: 12,
        paddingBottom: 12,
        backgroundColor: theme.palette.background.paper,
    },
    innerGrid: {

    },
    form: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formFieldContainer: {
        display: 'flex',
        width: '100%',
        marginRight: '1rem',
        marginLeft: '1rem',
        marginBottom: 8,
        marginTop: 8
    },
    inputLabel: {
        marginLeft: '1rem',
        marginRight: '1rem',
        width: '8rem',
        fontSize: 14,
        zIndex: 1000,
        lineHeight: 1.75,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center'
    },
    textField: {
        width: 260,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    textArea: {
        width: '80%',
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    prefix: {
        width: 100,
        marginRight: 5
    },
    pictureButtonText: {
        color: theme.palette.type === 'light' ? theme.palette.text.secondary : theme.palette.background.paper,
        fontWeight: 'bold'
    },
    validationCondition: {
        textTransform: 'none',
    },
    alertIcon: {
        color: theme.palette.error.main
    },
    checkIcon: {
        color: theme.palette.success.main
    },
    tabCard: {
        display: 'flex',
        marginTop: 6,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary
    },
    saveButton: {
        marginRight: 10,
        padding: 8,
        width: 90,
        alignSelf: 'center'
    },
    deleteButton: {
        marginLeft: 10,
        padding: 8,
        width: 90,
        alignSelf: 'center',
        backgroundColor: theme.palette.error.main,
        color: 'white'
    },
    cancelButton: {
        padding: 8,
        width: 90,
        alignSelf: 'center'
    },
    table: {
        backgroundColor: theme.palette.background.paper,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));

function nullToString(obj) {
    for (var i in obj) {
        if (obj[i] === null) {
            obj[i] = ''
        }
        if (obj['id'] === '') {
            obj['id'] = Number(obj.sequence)
        }
    }
    return obj;
}
function fixEmailString(emails) {
    let replaceCommas = emails.replace(/,/g, ";")
    let splitSemi = replaceCommas.split(";")
    for (let i = 0; i < splitSemi.length; i++) {
        splitSemi[i] = splitSemi[i].trim();
    }
    return splitSemi.join();
}
const formatEmailsArray = (emails) => {
    if (emails) {
    return emails.split(',');
    }
    return []
}


export default function EmailGroupCreate(props) {
    const dataPassedFromTable = useSelector((state) => state.emailGroup.formDataFromTableEmailGroup);
    const isEditingEmailGroup = useSelector((state) => state.emailGroup.isEditingEmailGroup);
    const isCreatingEmailGroup = useSelector((state) => state.emailGroup.isCreatingEmailGroup);
    const allEmailGroups = useSelector((state) => state.emailGroup.allEmailGroups);
    const history = useHistory();
    const classes = useStyles();

    const [formData, setFormData] = useState(nullToString(dataPassedFromTable))
    const [emailsForChips, setEmailsForChips] = useState(formatEmailsArray(formData.email))
    const [editVal, setEditVal] = useState('')
    //Loading
    const [isLoading, setIsLoading] = useState(false);

    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [warnDialog, setWarnDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    const [editDialog, setEditDialog] = useState({ isOpen: false, emailValue: '', isCreating: false});

    const formik = useFormik({
        initialValues: formData,
        onSubmit: async (values) => {
            if (isCreatingEmailGroup && allEmailGroups.length > 0 && allEmailGroups.findIndex(r => r.mailGroup.toUpperCase() === values.mailGroup.toUpperCase()) > -1) {
                setWarnDialog({
                    isOpen: true,
                    title: 'Data Warning',
                    subTitle: <><Box component="div">Email Group name must be unique.  Email Group "{values.mailGroup}" already exists.</Box></>,
                })
                return;
            }
            values.email = emailsForChips.join()
            let valsWithoutSloc = {email: values.email, id: values.id, mailGroup: values.mailGroup}
            try {
                await EmailGroupService.saveEmailGroup(valsWithoutSloc)
                history.push('/admin/email-group/home')
            } catch (e) {
                console.log(e.message)
            }

        },
    });

    //if page reload, send user back to home
    if (!isEditingEmailGroup && !isCreatingEmailGroup) {
        history.push('/admin/email-group/home')
    }
   
    const handleDeleteEmailGroup = async () => {
        setConfirmDialog({
            isOpen: true,
            title: `Confirm`,
            subTitle: <><Box component="div">Are you sure you want to delete {formData.mailGroup} from the system?</Box></>,
            onConfirm: async () => {
                try {
                    let response = await EmailGroupService.deleteEmailGroup(formData)
                    if (response) {
                        history.push('/admin/email-group/home')
                    }
                } catch (e) {
                    console.log(e.message)
                }
                setConfirmDialog({ ...confirmDialog, isOpen: false })
            }

        })
    }
    const handleDeleteSingleEmail = (index) => {
        let removed = emailsForChips.filter((x, i) => i !== index);
        setEmailsForChips(removed)
    }
    const handleEditSingleEmail = (index) => {
        const indexToUpdate = index;
        const valueToEdit = emailsForChips[indexToUpdate];
        setEditVal(valueToEdit)

        setEditDialog({
            isOpen: true,
            emailValue: valueToEdit,
            indexToUpdate: indexToUpdate,
            isCreating: false
        })
    }
    const onUpdateEditEmail = (indexToUpdate) => {
        let newArr;
        if (indexToUpdate > emailsForChips.length - 1) {
            newArr = [...emailsForChips, editVal]
        } else {
            newArr = emailsForChips.map((x, i) => i !== indexToUpdate ? x : editVal)
        }

        setEmailsForChips(newArr.join().split(','))
        setEditDialog({ ...editDialog, isOpen: false, isCreating: false })
        setEditVal('')
    }
    const handleAddEmail = () => {
        let indexToUpdate = emailsForChips.length
        setEditDialog({ ...editDialog, isOpen: true, indexToUpdate: indexToUpdate, isCreating: true })
    }

    if (isLoading) {
        return (
            <Backdrop className={classes.backdrop} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>)
    }
    return (
        <>
            <Container>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        {isCreatingEmailGroup ?
                            <> Create New Email Group </>
                            :
                            <> Edit Email Group </>
                        }
                    </h2>
                </div>

                <Grid container spacing={3} style={{display: 'flex', flexDirection: 'column'}}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', marginTop: 10, marginBottom: 10 }}>
                        <Button className={classes.saveButton} startIcon={<ContentSave />} onClick={formik.handleSubmit} size='small' variant='contained' color='primary'>
                            Save
                    </Button>
                        <Button className={classes.cancelButton} onClick={() => history.push('/admin/email-group/home')} size='small' variant='contained' color='default'>
                            Cancel
                    </Button>
                        {isEditingEmailGroup ?
                            <Button className={classes.deleteButton} startIcon={<Delete style={{ color: 'white' }} />} onClick={handleDeleteEmailGroup} size='small' variant='contained'>
                                Delete
                    </Button>
                            : ''}
                    </div>
                    <Card className={classes.formCard}>
                        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.innerGrid}>
                            <Formik>
                                <Form
                                    className={classes.form}
                                    onSubmit={formik.onSubmit}
                                >
                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Name:
                                   </InputLabel>
                                        <TextField
                                            id="mailGroup"
                                            name="mailGroup"
                                            className={classes.textField}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.mailGroup}
                                            onChange={formik.handleChange} />
                                    </div>
                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Sloc:
                                   </InputLabel>
                                        <TextField
                                            id="sloc"
                                            name="sloc"
                                            disabled
                                            className={classes.textField}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.sloc}
                                            onChange={formik.handleChange} />
                                    </div>

                                    <div className={classes.formFieldContainer} >
                                        <InputLabel className={classes.inputLabel}>
                                            Emails:
                                   </InputLabel>
                                        <div>
                                            {emailsForChips.map((v, i) =>
                                                <Chip
                                                    icon={
                                                        <EmailEditOutline
                                                            style={{ fontSize: 20 }}
                                                        />}
                                                    label={v}
                                                    size='small'
                                                    variant='outlined'
                                                    style={{padding: 4, margin: 4}}
                                                    onDelete={() => handleDeleteSingleEmail(i)}
                                                    onClick={() => handleEditSingleEmail(i)}
                                                    color="info" />)
                                            }
                                            <IconButton aria-label="add" color='primary' onClick={handleAddEmail} style={{ padding: 0, margin: 0 }}>
                                                <PlusCircleOutline fontSize='large'  />
                                            </IconButton>
                                        </div>
                                    </div>
                                </Form>
                            </Formik>
                        </Grid>
                    </Card>
                </Grid>

            </Container >
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <WarnDialog
                warnDialog={warnDialog}
                setWarnDialog={setWarnDialog}
            />
            <EditDialog
                editDialog={editDialog}
                setEditDialog={setEditDialog}
                editVal={editVal}
                setEditVal={setEditVal}
                onUpdateEditEmail={onUpdateEditEmail}
                />
            <Backdrop className={classes.backdrop} open={!formik.values}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};